import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/pages/ResourceSetting/Widgets/TextField';

export default function GoogleDescriptionField({
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <TextField
      title="長標題"
      description="長度上限為90個半形字元，請勿輸入表情符號，驚嘆號至多輸入一個"
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      singleLine="true"
      squat
    />
  );
}

GoogleDescriptionField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

GoogleDescriptionField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: true,
};
